import memoize from '@devexperts/utils/dist/function/memoize';
import axios from 'axios';
import pLimit from 'p-limit';
import { PageTitle, PdfDocumentType } from '../constants/print.constant';
import { TAnalysisAccountDetailResponse } from '../models/analysis-account-details.model';

const pdfServiceBaseUrl = '/api/reports/v2';
// const pdfServiceBaseUrl = 'http://localhost:2960/api/reports/v2';
const pdfServiceUrl = `${pdfServiceBaseUrl}/file`;
const mergePdfUrl = `${pdfServiceBaseUrl}/merge/PDF`;
// export const reportType = 'eWealthManager_Proposal';
export const reportType = 'WBLeadPortal_Report';
export const contentType = 'application/pdf';

const limit = pLimit(10);

const postData = (reportData: any) => {
	return axios.post(pdfServiceUrl, reportData, {
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/pdf',
			'X-Application': 'WBLP',
		},
		responseType: 'blob',
	});
};

export const getCoverPagePdfData = (firstName: string, lastName: string, advisorDetails: string, advisorPhotoBase64: string, advisorLogoBase64: string) => {
	const requestReportDataPayload = {
		reportType,
		responseContentType: contentType,
		pageLayout: 'Letter',
		usePageLayout: true,
		landscape: true,

		margin: {
			top: '0px',
			left: '0px',
			right: '0px',
			bottom: '0px',
		},
		reportData: {
			documentType: PdfDocumentType.CoverPageComponent,
			data: {
				firstName: firstName,
				lastName: lastName || '',
				advisorDetails: JSON.parse(advisorDetails),
				advisorPhotoBase64: advisorPhotoBase64 || '',
				advisorLogoBase64: advisorLogoBase64 || ''
			},
		},
	};
	return  limit(() => postData(requestReportDataPayload));
};

export const getFirstPagePdfData = (companyName: string, investorName: string, goalAccountDetails: TAnalysisAccountDetailResponse, selectedRiskProfilImgUrl: any) => {
	const requestReportDataPayload = {
		reportType,
		responseContentType: contentType,
		pageLayout: 'Letter',
		usePageLayout: true,
		landscape: true,

		margin: {
			top: '30px',
			left: '50px',
			right: '50px',
			bottom: '30px',
		},
		reportData: {
			documentType: PdfDocumentType.FirstPageComponent,
			data: {
				companyName,
				investorName,
				goalAccountDetails,
				selectedRiskProfilImgUrl
			},
		},
	};
	return limit(() => postData(requestReportDataPayload));
};

export const getSecondPagePdfData = (companyName: string, investorName: string) => {
	const requestReportDataPayload = {
		reportType,
		responseContentType: contentType,
		pageLayout: 'Letter',
		usePageLayout: true,
		landscape: true,

		margin: {
			top: '30px',
			left: '50px',
			right: '50px',
			bottom: '30px',
		},
		reportData: {
			documentType: PdfDocumentType.SecondPageComponent,
			data: {
				companyName,
				investorName
			},
		},
	};
	return limit(() => postData(requestReportDataPayload));
};

export const getThirdPagePdfData = (companyName: string, investorName: string) => {
	const requestReportDataPayload = {
		reportType,
		responseContentType: contentType,
		pageLayout: 'Letter',
		usePageLayout: true,
		landscape: true,

		margin: {
			top: '30px',
			left: '50px',
			right: '50px',
			bottom: '30px',
		},
		reportData: {
			documentType: PdfDocumentType.ThirdPageComponent,
			data: {
				companyName,
				investorName
			},
		},
	};
	return limit(() => postData(requestReportDataPayload));
};

export const getFourthPagePdfData = (companyName: string, investorName: string) => {
	const requestReportDataPayload = {
		reportType,
		responseContentType: contentType,
		pageLayout: 'Letter',
		usePageLayout: true,
		landscape: true,

		margin: {
			top: '30px',
			left: '50px',
			right: '50px',
			bottom: '30px',
		},
		reportData: {
			documentType: PdfDocumentType.FourthPageComponent,
			data: {
				companyName,
				investorName
			},
		},
	};
	return limit(() => postData(requestReportDataPayload));
};

export const getFifthPagePdfData = (companyName: string, investorName: string) => {
	const requestReportDataPayload = {
		reportType,
		responseContentType: contentType,
		pageLayout: 'Letter',
		usePageLayout: true,
		landscape: true,

		margin: {
			top: '30px',
			left: '50px',
			right: '50px',
			bottom: '30px',
		},
		reportData: {
			documentType: PdfDocumentType.FifthPageComponent,
			data: {
				companyName,
				investorName
			},
		},
	};
	return limit(() => postData(requestReportDataPayload));
};

export const getSixthPagePdfData = (companyName: string, investorName: string) => {
	const requestReportDataPayload = {
		reportType,
		responseContentType: contentType,
		pageLayout: 'Letter',
		usePageLayout: true,
		landscape: true,

		margin: {
			top: '30px',
			left: '50px',
			right: '50px',
			bottom: '30px',
		},
		reportData: {
			documentType: PdfDocumentType.SixthPageComponent,
			data: {
				companyName,
				investorName
			},
		},
	};
	return limit(() => postData(requestReportDataPayload));
};

export function getByteArrayStringFromBlob(data: Blob) {
	const promise: Promise<string> = new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			const arrayBuffer = reader.result as ArrayBuffer;
			const bytes = new Uint8Array(arrayBuffer);

			const base64String = btoa(
				bytes.reduce(function(data, byte) {
					return data + String.fromCharCode(byte);
				}, ''),
			);
			// let base64String = btoa(String.fromCharCode(...bytes));
			resolve(base64String);
		};
		reader.readAsArrayBuffer(data);
	});

	return promise;
}

export const b64toBlob = (b64Data: string, contentType = 'application/pdf', sliceSize = 512) => {
	// b64Data = "data:application/pdf;base64, " + b64Data;
	b64Data = b64Data.replace(/^[^,]+,/, '');
	b64Data = b64Data.replace(/\s/g, '');
	const byteCharacters = atob(b64Data);
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}

	const byteArray = new Uint8Array(byteNumbers);

	const blob = new Blob([byteArray], { type: 'application/pdf' });
	return blob;
};